import * as React from "react";
import "./CodeWithCopyButton.scss";
import { setClipboard } from "../commons/utils/clipboard";
import IconButton from "../commons/components/buttons/IconButton";

export default function CodeWithCopyButton({
  text,
  icon,
}: {
  text: string;
  icon: React.JSX.Element;
}) {
  return (
    <div className="code-with-copy-button-main">
      <div className="code-to-copy-section">
        <div className="code-to-copy-icon">{icon}</div>
        <pre className="code-to-copy">{text}</pre>
      </div>
      <IconButton iconClassName="ic_copy clickable" onClick={() => setClipboard(text)} />
    </div>
  );
}
